export const contactContent = {
  hero: {
    title: "Plant Yourself Here",
    quote: "It is guaranteed that you will one day make soil. But will you afford yourself the privilege to stand on it?"
  },
  invitation: "Whether you want to collect, collaborate, ask questions, or simply stay connected—this is where you root in. \"We are open to collaborating with any business that desires to produce products and services that are in alignment with Earth Rights Business principles.\"",
  form: {
    success: {
      title: "Message Planted",
      desc: "The frequency of alignment has been received."
    }
  },
  closing: "The only thing centralized about our community is our shared frequency of abundance and reverence for life."
};